import React from 'react';

import { MaskProps, useMask } from '@react-input/mask';
import FormFieldLabel from './FormFieldLabel';
import { IFormFieldProps } from './models';
import { useFormField } from './useFormField';

type Props = IFormFieldProps & Required<Pick<MaskProps, 'mask' | 'replacement'>>;

function FormMaskField({ name, label, optional, size = 50, ...maskProps }: Props) {
  const { id, fieldProps, inputProps } = useFormField(name, size);

  const inputRef = useMask({
    ...maskProps,
    modify: (value) => ({ showMask: value !== undefined && value !== '' && value !== maskProps.mask }),
  });

  return (
    <div {...fieldProps}>
      {label && (
        <FormFieldLabel htmlFor={id} optional={optional}>
          {label}
        </FormFieldLabel>
      )}
      <input ref={inputRef} placeholder={maskProps.mask} {...inputProps} />
    </div>
  );
}

export default FormMaskField;
